<template>
  <core-main class="px-8 py-12">
    <template v-slot:toolbar-title>
      <v-btn icon>
        <v-icon
          @click="$router.push({ path: '/orders'})"
          v-text="'mdi-close'"
        />
      </v-btn>
      {{ $t('form.order.newName') }}
    </template>

    <v-row justify="space-around" class="fill-height pt-12">
      <v-col cols="5">
        <v-expansion-panels v-model="orderInfo.currentStep.step">
          <core-order-step
            v-for="(step, i) in orderSteps"
            :key="i"
            v-model="orderInfo"
            :title="_.get(step, 'text')"
            :subtitle="isActiveStep(i) ? (`Step ${i + 1} of ${_.size(orderSteps)}`) : ''"
            :icon="_.get(step, 'icon')"
            :is-active-step="isActiveStep(i)"
            :has-next-sub-step="hasNextSubStep"
            :has-previous-sub-step="hasPreviousSubStep"
          >
            <template
              v-if="activeSubStepComponent !== undefined"
              #content
            >
              <component
                :is="activeSubStepComponent"
                v-model="orderInfo"
                @new-address="test"
              />
            </template>
          </core-order-step>
        </v-expansion-panels>
      </v-col>

      <v-col cols="5">
        <core-order-summary
          :order-items="orderInfo.purchase.partSelect.selectedParts"
          @submit="submitOrder"
        />
      </v-col>
    </v-row>

    <v-dialog v-model="isNewAddressModalActive">
      <v-card>
        <v-card-title>
          New Address
        </v-card-title>

        <v-card-text>
          <form-address />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn>
            Save
          </v-btn>
        </v-card-actions>
        <!-- <v-card-title>
          asdf
        </v-card-title> -->
      </v-card>
    </v-dialog>
  </core-main>
</template>

<script>
import AuthMixin from '../../mixins/auth';

export default {

  mixins: [
    AuthMixin,
  ],

  data() {
    return {
      isNewAddressModalActive: false,

      orderInfo: {
        purchase: {
          number: {
            poNumber: '',
            name: '',
          },
          partSelect: {
            selectedParts: [
            ],
          }
        },
        delivery: {
          method: {
            method: '',
          },
        },
        shipping: {
          handler: {
            handler: '',
          },
          address: {
            address: '',
          },
          forwarder: {
            forwarder: '',
          },
        },
        currentStep: {
          step: 0,
          subStep: 0,
        },
      },

      defaultOrderInfo: {},
    };
  },

  computed: {
    activeSubStepComponent() {
      const { step } = this.orderInfo.currentStep;
      const { subStep } = this.orderInfo.currentStep;

      if (!this.orderSteps[step]) {
        return undefined;
      }
      if (!this.orderSteps[step].subSteps[subStep]) {
        return undefined;
      }
      return this.orderSteps[step].subSteps[subStep].component;
    },

    hasNextSubStep() {
      const { step } = this.orderInfo.currentStep;
      const { subStep } = this.orderInfo.currentStep;

      return this.orderSteps[step]
          && 1 + subStep < _.size(this.orderSteps[step].subSteps);
    },

    hasPreviousSubStep() {
      const { subStep } = this.orderInfo.currentStep;

      return subStep > 0;
    },

    orderSteps() {
      return [
        {
          text: 'Purchase Order Information',
          icon: 'mdi-bank-outline',
          subSteps: [
            { component: 'core-order-purchase-number' },
            { component: 'core-order-purchase-part-select' },
          ],
        },
        {
          text: 'Delivery Options',
          icon: 'mdi-calendar',
          subSteps: [
            { component: 'core-order-delivery-method' },
          ],
        },
        {
          text: 'Shipping Address',
          icon: 'mdi-map-marker',
          subSteps: [
            { component: 'core-order-shipping-handler' },
            { component: 'core-order-shipping-address' },
            { component: 'core-order-shipping-forwarder' },
          ],
        },
      ];
    },
  },

  watch: {
    'orderInfo.currentStep.step': {
      deep: true,

      handler() {
        this.orderInfo.currentStep.subStep = 0;
      },
    },
  },

  mounted() {
    this.defaultOrderInfo = _.cloneDeep(this.orderInfo);
  },

  methods: {
    test() {
      this.isNewAddressModalActive = !this.isNewAddressModalActive;
    },

    isActiveStep(step) {
      return step === this.orderInfo.currentStep.step;
    },

    async submitOrder(orderTotal) {
      const { Order } = this.$FeathersVuex.api;

      const parts = this.orderInfo.purchase.partSelect.selectedParts;

      const orderItems = _.map(_.filter(parts, p => p.quantity > 0), p => ({
        partId: p._id,
        quantity: p.quantity,
      }));

      const data = {
        purchaseOrderNo: this.orderInfo.purchase.number.poNumber,
        // eslint-disable-next-line max-len
        salesOrderNo: `KMS-BOM-${Math.random().toString(36).substring(9).toUpperCase()}`,
        pricing: orderTotal,
        status: 'In Progress',
        expires: moment().add(6, 'months').format('YYYY-MM-DD'),
        createdBy: this.user._id,
        deliverySpeed: this.orderInfo.delivery.method.method,
        forwarder: this.orderInfo.shipping.forwarder.forwarder.text,
        forwardingOption: this.orderInfo.shipping.handler.handler.text,
        shippingAddress: this.orderInfo.shipping.address.address,
        billingAddress: this.orderInfo.shipping.address.address,
        orderItems,
      };

      try {
        await new Order(data).save();
      } catch (e) {
        console.error(e);
      }

      this.orderInfo = _.cloneDeep(this.defaultOrderInfo);
      this.$router.push('/orders');
    },
  },
};
</script>
